import { render, staticRenderFns } from "./DisplayStoreItemsDelete3.vue?vue&type=template&id=f56188d2&"
import script from "./DisplayStoreItemsDelete3.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsDelete3.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsDelete3.vue?vue&type=style&index=0&id=f56188d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports